export default "__VITE_ASSET__9b75c61a__"